import React from 'react';
import PlatformChips from '../PlatformChips';
import { platformLabel, fmtNum, fmtDate } from '../soundstatsHelpers';

// Recent reels / shorts with views, likes, comments.

function ShortCard({ it, platformKey }) {
  const a = it.latestAudience || {};
  const title = it.title || `Reel · ${platformLabel(platformKey)}`;
  return (
    <div className="ss-short-card">
      <div className="ss-short-title">{title}</div>
      {it.description && <div className="ss-short-desc">{it.description}</div>}
      <div className="ss-short-stats">
        <span><b>{fmtNum(a.views)}</b> views</span>
        <span><b>{fmtNum(a.likes)}</b> likes</span>
        <span><b>{fmtNum(a.comments)}</b> comments</span>
      </div>
      <div className="ss-short-foot">
        <span className="ss-short-date">{fmtDate(it.createdAt)}</span>
        {it.externalUrl && <a className="ss-short-link" href={it.externalUrl} target="_blank" rel="noopener noreferrer">View ↗</a>}
      </div>
    </div>
  );
}

export default function ShortsGroup({ platforms, entries, chipIdx, setChipIdx }) {
  let cards;
  if (chipIdx === 0) {
    const all = [];
    platforms.forEach(e => (e.items || []).forEach(it => all.push({ it, key: e.key })));
    cards = all.slice(0, 60).map((o, i) => <ShortCard key={i} it={o.it} platformKey={o.key} />);
  } else {
    const entry = entries[chipIdx];
    const items = entry ? entry.items.slice(0, 30) : [];
    cards = items.map((it, i) => <ShortCard key={i} it={it} platformKey={entry.key} />);
  }

  return (
    <>
      <div className="ss-content-title"><h2>Shorts</h2><span className="ss-sec-hint">Recent reels & shorts</span></div>
      <PlatformChips entries={entries} idx={chipIdx} onPick={setChipIdx} />
      <div className="ss-short-grid">{cards.length ? cards : <div className="ss-empty">No shorts</div>}</div>
    </>
  );
}
